import { initAuthenticate, configurationService } from '@ibe/tupvid-components';
import { fetchJSON, LoggerFactory } from '@ibe/services';
import { ConfigurationModel } from '@ibe/tupvid-services';
import dayjs from 'dayjs';
import { Language } from '../Translations';

const logger = LoggerFactory.get('config');
const customConfig: Partial<ConfigurationModel> = {
  defaultLanguage: 'en',
  apiUrl: '/api',
  configUrl: '/config.json',
  session: {
    expirationTimeNotificationOffset: 5
  }
};

function initLanguage(): void {
  configurationService.setLang(Language.EN_US);
  const langOnly = configurationService.lang.split('-')[0];
  dayjs.locale(langOnly);
}

const boot = async (): Promise<void> => {
  configurationService.hydrate(customConfig);
  const url = configurationService.configuration.configUrl;
  if (url) {
    const externalConfig = (await fetchJSON(url)) as Partial<ConfigurationModel>;
    configurationService.hydrate(externalConfig);
  }
  await initAuthenticate(configurationService.configuration);

  initLanguage();

  logger.log('App hydrated');
};

export default boot;
